// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"58c8a8c1","239":"9974eb23","453":"fb4c1376","732":"260821ae"}[chunkId] + ".chunk.js";
};